if (!customElements.get('app-swiper-boxes')) {
  customElements.define(
    'app-swiper-boxes',
    class AppSupport extends HTMLElement {
      constructor() {
        super();

        let thumbConfig = {
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
        };

        if (this.dataset.direction === 'vertical') {
          thumbConfig = {
            slidesPerView: 3,
            freeMode: true,
            mousewheel: true,
            direction: 'horizontal',
            watchSlidesProgress: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              890: {
                direction: 'vertical',
              },
            },
          };
        }

        this.sliderThumbs = new Swiper('.slider-thumbs', thumbConfig);

        this.SliderMain = new Swiper('.slider-main', {
          thumbs: {
            swiper: this.sliderThumbs,
          },
        });
      }
    },
  );
}
